export default __webpack_public_path__ + "static/media/configure-menu.e9bed891.svg";